export enum DriversIntegrationTypes {
  GOOGLE_DRIVE = 'google-drive',
  LOCAL_PICKER = 'local-picker'
};

export interface ExternalFilesData {
  name: string;
  fileId: string;
  size: number;
  type: string;
  iconUrl: string;
}

export interface ExternalFolderData {
  name: string;
  folderId: string;
  size: number;
  iconUrl: string;
}

export interface FilesItemsList {
  files: Array<ExternalFilesData>;
  folders: Array<ExternalFolderData>;
  type?: DriversIntegrationTypes;
}

export interface FilesUploadResponse {
  ok: boolean;
  uploadedCount: number;
  errorCount: number;
  unchangedCount: number;
  allFiles: FileData[];
}

export interface FileData {
  fileId: string;
  name: string;
  userId: string;
  provider: DriversIntegrationTypes;
  mimeType: string;
  modifiedTime: number;
  progress: number;
  size: number;
  error: boolean;
  status: FileUploadStatus;
  uploadType?: 'document' | 'media';
  file?: File;
  r2Key?: string;
  backendPath?: string;
}

export enum FileUploadStatus {
  UPLOADED = 'UPLOADED',
  ERROR = 'ERROR',
  UNCHANGED = 'UNCHANGED',
  PENDING = 'PENDING',
  GETTING_URL = 'GETTING_URL',
  UPLOADING = 'UPLOADING',
  PROVIDER_ERROR = 'PROVIDER_ERROR',
  NOT_SUPPORTED_TYPE = 'NOT_SUPPORTED_TYPE',
  NOT_SUPPORTED_SIZE = 'NOT_SUPPORTED_SIZE',
  MAX_COUNT_REACHED = 'MAX_COUNT_REACHED',
}

export interface FilesProjectAssociation {
  fileId: string;
  scanProjectId: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface FilesUploadBody {
  fileIds: string[],
  folderIds: string[];
};